// @ts-nocheck
import React from 'react'
import styled from 'styled-components'
import { useMediaQuery } from 'react-responsive'
import PropTypes from 'prop-types'
import ButtonBase from './ButtonBase'
import { mediaQueriesBreakpoints } from '../../styles/mixins'
import { getTranslatedTextByKey, spaceToDash } from 'utils/utils'

const Wrapper = styled.div`
	background-color: var(--clear);
	border-radius: 4px;
	box-shadow: 0 0 0 0 rgba(0, 0, 0, 0) inset, var(--defaultShadow2);
	transition: box-shadow 0.5s ease-in-out;
	height: 100%;
	cursor: pointer;
	overflow: hidden;
	position: relative;

	.image-wrapper {
		aspect-ratio: 4 / 3;
		position: relative;

		img {
			aspect-ratio: 4 / 3;
			object-fit: cover;
			transition: transform 0.5s ease;
			width: 100%;
		}
	}

	&::after {
		content: '';
		box-shadow: none;
		transition: all 0.5s ease;
	}

	&:hover {
		&::after {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			box-shadow: var(--innerShadow);
			overflow: hidden;
		}

		.image-wrapper {
			img {
				transform: scale(1.05);
			}
		}
	}

	&:active {
		transform: scale(0.95);
	}
`

const Content = styled.div`
	padding: 20px 20px 25px;
	text-align: center;
`

const Title = styled.div`
	color: var(--err);
	${({ theme }) => theme.typography.h3};
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 1; /* number of lines to show */
	line-clamp: 1;
	-webkit-box-orient: vertical;
	padding: 0 10px;
`

const Description = styled.div`
	color: var(--footerAndDarkBackgrounds);
	${({ theme }) => theme.typography.BodyRegular};
	${({ $isBig }) => ($isBig ? `padding: 10px 10px 0` : `padding: 7px 10px 0`)};
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2; /* number of lines to show */
	line-clamp: 2;
	-webkit-box-orient: vertical;
	height: 51px;
`

const ActionButton = styled(ButtonBase)`
	width: 155px;
	margin-block-start: 20px;
	z-index: 1;
`

const GridItem = ({ data, $isBig = false, onClick }) => {
	const isMobile = !useMediaQuery({ query: mediaQueriesBreakpoints.laptop })
	const currentImg = data && (isMobile ? data.imgMobileUrl : data.imgDesktopUrl)
	const imageTitle = data.offerTitle ?? 'item-image'

	return (
		<Wrapper $isBig={$isBig} $isMobile={isMobile} onClick={onClick} data-testid="item-card">
			{currentImg && (
				<div className="image-wrapper">
					<img id={`deals-page-item-${spaceToDash(data?.offerTitle)}-pic`} src={currentImg} alt={imageTitle} data-testid="item-image" />
				</div>
			)}
			<Content $isBig={$isBig}>
				{data?.offerTitle && <Title data-testid="offer-title">{data.offerTitle}</Title>}
				<Description $isBig={$isBig} data-testid="offer-description">
					{data.offerDescription}
				</Description>
				<ActionButton id={`deals-page-item-${spaceToDash(data?.offerTitle)}-order-now`} onClick={onClick} data-testid="order-now-button">
					{getTranslatedTextByKey('eCommerce.deals.orderNow')}
				</ActionButton>
			</Content>
		</Wrapper>
	)
}

export default GridItem

GridItem.propTypes = {
	data: PropTypes.object,
	$isBig: PropTypes.bool,
	onClick: PropTypes.func,
}
